import * as React from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';

interface EditabilityPluginProps {
  disabled?: boolean;
}

export function EditabilityPlugin({
  disabled = false,
}: EditabilityPluginProps) {
  const [editor] = useLexicalComposerContext();

  React.useEffect(() => {
    editor.setEditable(!disabled);
  }, [disabled, editor]);

  return null;
}
